<template>  
  <div class="qmkey-view-title" >
    {{ title }}
  </div>
</template>

<script>
 export default {
   name: 'ViewTitle',
   props: {
     title: String,
   },
 }
</script>
